import classNames from "classnames";
import React from "react";
import { ListGroup, ListGroupItem } from "reactstrap";

interface ListItem {
  title?: React.ReactNode;
  text?: React.ReactNode;
  color?: string;
  onClick?: () => void;
  icon?: React.ReactNode;
}

interface ListProps {
  items?: ListItem[];
}

const List = ({ items = [] }: ListProps) => {
  return (
    <ListGroup flush>
      {items.map(({ title, text, color, onClick, icon }, index) => {
        return (
          <ListGroupItem
            action={!!onClick}
            onClick={onClick}
            color={color}
            style={{ cursor: onClick ? "pointer" : "inherit", columnGap: "2rem", rowGap: "1rem" }}
            className={classNames("d-flex align-items-center flex-wrap", { "bg-transparent": !color })}
            key={index}
          >
            {icon}
            <div>
              <small className="font-weight-bold" children={title} />
              <div>{text || "‎"}</div>
            </div>
          </ListGroupItem>
        );
      })}
    </ListGroup>
  );
};

export default List;
